<template>
  <a-modal
    :visible="visible"
    :title="modalTitle"
    width="900px"
    :footer="null"
    @cancel="$emit('close')"
  >
    <div v-if="teacher">
      <div class="row mb-3 p-3 bg-light rounded mx-0 align-items-center">
        <div class="col-md-4 col-12 mb-2 mb-md-0">
          <div class="text-muted font-size-12 text-uppercase font-weight-bold">Teacher Name</div>
          <div class="font-size-16 font-weight-bold text-dark">{{ teacher.teacher_name }}</div>
        </div>
        <div class="col-md-3 col-6 text-center">
          <div class="text-muted font-size-12 text-uppercase font-weight-bold">Total Updates</div>
          <div class="font-size-18 font-weight-bold text-primary">{{ teacher.total_updates_logged || (teacher.recent_logs ? teacher.recent_logs.length : 0) }}</div>
        </div>
        <div class="col-md-3 col-6 text-center">
          <div class="text-muted font-size-12 text-uppercase font-weight-bold">Active Plans</div>
          <div class="font-size-18 font-weight-bold text-success">{{ teacher.no_of_lesson_plans || 0 }}</div>
        </div>
        <div class="col-md-2 col-12 text-center mt-2 mt-md-0">
          <div class="text-muted font-size-12 text-uppercase font-weight-bold">Sections</div>
          <div class="font-size-18 font-weight-bold text-info">{{ teacher.no_of_sections || 0 }}</div>
        </div>
      </div>

      <div class="air__utils__scrollTable">
        <a-table
          :dataSource="teacher.recent_logs || []"
          :columns="columns"
          :pagination="{ pageSize: 10 }"
          rowKey="id"
          size="middle"
        >
          <template slot="plan" slot-scope="text, record">
            <div>
              <span class="font-weight-bold text-dark">{{ record.lesson_plan_name }}</span>
              <div class="font-size-12 text-muted">
                {{ record.class_name }} - {{ record.section_name }} ({{ record.subject_name }})
              </div>
            </div>
          </template>

          <template slot="topic" slot-scope="text, record">
            <div>
              <span class="font-weight-bold">{{ record.topic_name }}</span>
              <div v-if="record.sub_topic_name" class="font-size-12 text-primary">
                ↳ Subtopic: {{ record.sub_topic_name }}
              </div>
            </div>
          </template>

          <template slot="status" slot-scope="status">
            <a-tag :color="getStatusColor(status)" :style="getStatusStyle(status)">
              {{ status || 'Not Started' }}
            </a-tag>
          </template>

          <template slot="info" slot-scope="text, record">
            <div>
              <span>{{ record.date || '-' }}</span>
              <div v-if="record.period" class="font-size-12 text-muted">
                Period: {{ record.period }}
              </div>
              <a-tag v-if="record.is_substitute" color="blue" size="small" class="mt-1">
                Substitute
              </a-tag>
            </div>
          </template>

          <template slot="action" slot-scope="text, record">
            <a-button
              v-if="record.lesson_plan_id"
              type="primary"
              size="small"
              @click="navigateToPlan(record.lesson_plan_id)"
            >
              View Plan
            </a-button>
          </template>
        </a-table>
      </div>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'TeacherLogsModal',
  props: {
    visible: Boolean,
    teacher: Object,
  },
  computed: {
    modalTitle() {
      return this.teacher ? `Teacher Progress Log Details - ${this.teacher.teacher_name}` : 'Teacher Log Details'
    },
    columns() {
      return [
        { title: 'Date / Period', key: 'info', scopedSlots: { customRender: 'info' }, width: 130 },
        { title: 'Lesson Plan & Section', key: 'plan', scopedSlots: { customRender: 'plan' }, width: 220 },
        { title: 'Topic / Subtopic Covered', key: 'topic', scopedSlots: { customRender: 'topic' }, width: 220 },
        { title: 'Status', dataIndex: 'status', key: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 110 },
        { title: 'Remarks', dataIndex: 'remarks', key: 'remarks', width: 150 },
        { title: 'Action', key: 'action', scopedSlots: { customRender: 'action' }, align: 'center', width: 100 },
      ]
    },
  },
  methods: {
    getStatusColor(status) {
      const s = (status || '').toLowerCase()
      if (s === 'completed') return 'green'
      if (s === 'in progress') return 'blue'
      if (s === 'started') return 'orange'
      return '#595959'
    },
    getStatusStyle(status) {
      const color = this.getStatusColor(status)
      if (color === '#595959') {
        return { color: '#ffffff', backgroundColor: '#595959', borderColor: '#595959' }
      }
      return {}
    },
    navigateToPlan(planId) {
      this.$emit('close')
      this.$router.push(`/lessonplan/details/${planId}`)
    },
  },
}
</script>

<style scoped>
.font-weight-bold {
  font-weight: 600;
}
</style>
